module.exports = __webpack_public_path__ + "static/media/clubs-queen.dd384225.png";